export const CONFIG = {
  SHUTDOWN_POWER_DURATION: {
    default: 10,
    min: 0,
    max: 60,
  },

  POWER_DURATION: {
    default: 60,
    min: 0,
    max: 180,
  },

  DEFROST_DURATION: {
    default: 30,
    min: 0,
    max: 60,
  },

  RETURN_AIR_DISCREPANCY_THRESHOLD: {
    upper: {
      default: 2,
      min: 0,
      max: 10,
    },
    lower: {
      default: 5,
      min: 0,
      max: 10,
    },
  },

  SUPPLY_AIR_DISCREPANCY_THRESHOLD: {
    upper: {
      default: 2,
      min: 0,
      max: 10,
    },
    lower: {
      default: 5,
      min: 0,
      max: 10,
    },
  },
} as const

export const ISSUES_DISPLAY_ORDER: Record<string, number> = {
  Shutdown: 1,
  'No Data': 2,
  'Return Air Discrepancy': 3,
  'Supply Air Discrepancy': 4,
}
